import * as mutationTypes from './mutationTypes';
import mutations from './mutations';
import actionsFactory from './actions';
import getters from './getters/index';
import IBetSlipState from './types';

export {
    mutationTypes,
    mutations,
    IBetSlipState,
    actionsFactory,
    getters,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/betSlip/index.ts